import { Component, HostBinding } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {
	DocumentsLastConnectionWidgetComponent
} from '../../commercial-documents/components/dashboard/documents-last-connection-widget.component';
import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';

import { FavoriteOrdersComponent } from './dashboard/favorite-orders.component';
import { ExceptionReportComponent } from './dashboard/exception-report.component';
import { ScheduleBusinessOrderSituationComponent } from './dashboard/schedule-business-order-situation.component';
import { TimeInStockComponent } from './dashboard/time-in-stock.component';
import { OrderSituationComponent } from './dashboard/order-situation.component';

@Component({
	selector: 'copo-order-dashboard',
	templateUrl: './order-dashboard.component.html',
	imports: [
		TranslateModule,
		NgIf,
		DocumentsLastConnectionWidgetComponent,
		OrderSituationComponent,
		TimeInStockComponent,
		ScheduleBusinessOrderSituationComponent,
		ExceptionReportComponent,
		FavoriteOrdersComponent
	]
})
export class OrderDashboardComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	user: User;
	readonly showDocumentsLastConnectionWidget: boolean;

	constructor(
		private readonly userService: UserService,
	) {
		this.user = this.userService.user;
		this.showDocumentsLastConnectionWidget = this.user.hasService('PDOCS')
			&& (this.user.hasServiceParameterEqualsTo('PDOCS', 'OrderAcknowledgment', 'True')
				|| this.user.hasServiceParameterEqualsTo('PDOCS', 'Invoice', 'True')
				|| this.user.hasServiceParameterEqualsTo('PDOCS', 'Certificate', 'True')
				|| this.user.hasServiceParameterEqualsTo('PDOCS', 'DispatchAdvice', 'True')
				|| this.user.hasServiceParameterEqualsTo('PDOCS', 'XCarb', 'True'));
	}
}
